var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconYoutube = function SvgIconYoutube(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.32 14.5 4.336-2.5-4.336-2.5zm9.649-6.523q.156.585.234 1.601.078.977.078 1.72l.04.702q0 2.734-.352 4.024-.313 1.133-1.446 1.445-.585.156-2.226.234a61 61 0 0 1-2.969.079L12 17.82q-5.235 0-6.523-.352-1.133-.312-1.446-1.445-.156-.586-.234-1.563a23 23 0 0 1-.078-1.758L3.679 12q0-2.735.352-4.023.313-1.133 1.446-1.445.586-.157 2.187-.235a64 64 0 0 1 3.008-.078L12 6.18q5.235 0 6.523.352 1.133.312 1.446 1.445"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconYoutube);
export { ForwardRef as ReactComponent };